import { defineStore } from 'pinia';
import { CategoryCode, TabType, } from 'config-request/src/interfaces/feature-show-all';
import { SubCategoryCode } from 'config-request/src/interfaces/feature-list';
import { getFeatureData } from 'config-request';
import { useShowAllListStore } from './show-all-list';
import { useFeatureListStore } from './feature-list';
const componentMap = {
    //电池
    battery: {
        componentName: 'MBattery',
        popupOptional: false,
    },
    // 颜色
    color: {
        componentName: 'MColor',
        popupOptional: false,
    },
    // 轮毂
    wheel: {
        componentName: 'MWheel',
        popupOptional: false,
    },
    //外观定制 addbtn
    exterior_custom: {
        componentName: 'ExteriorCustomizedPopup',
        popupOptional: true,
        traceData: {
            page: '外观定制列表弹窗',
        },
    },
    // 内饰顶棚
    interior: {
        componentName: 'MInterior',
        popupOptional: false,
    },
    // 钥匙
    key: {
        componentName: 'MKey',
        popupOptional: false,
    },
    // 定制座舱
    cockpit_custom: {
        componentName: 'InteriorCustomizedPopup',
        popupOptional: true,
        traceData: {
            page: '座舱定制列表弹窗',
        },
    },
    // 选装
    sub_optional: {
        componentName: 'OptionalCustomizedPopup',
        popupOptional: true,
        traceData: {
            page: '选装列表弹窗',
        },
    },
    // 定制/选装 某一项
    option_item: {
        componentName: 'MOptionDetail',
        popupOptional: true,
    },
};
export const useConfigShowAllStore = defineStore('config-show-all', {
    getters: {
        /**
         * 图片
         */
        configImgs() {
            const showAllListStore = useShowAllListStore();
            let logo_url = '';
            let img_url = '';
            if (showAllListStore.data?.logo_url) {
                logo_url = showAllListStore.data.logo_url;
            }
            if (showAllListStore.data?.img_url) {
                img_url = showAllListStore.data.img_url;
            }
            return {
                logo_url,
                img_url,
            };
        },
        /**
         * 总价
         */
        totalPrice() {
            const showAllListStore = useShowAllListStore();
            return showAllListStore.data?.price_info?.total_price ?? 0;
        },
        /**
         * 原价
         */
        originPrice() {
            const showAllListStore = useShowAllListStore();
            return showAllListStore.data?.origin_price ?? 0;
        },
        /**
         * 总价描述
         */
        totalPriceDesc() {
            const showAllListStore = useShowAllListStore();
            return showAllListStore.data?.price_info?.total_price_desc ?? '';
        },
        /**
         *  提示信息
         * @returns
         */
        tipsList() {
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore?.data?.tip_list)
                return [];
            return showAllListStore.data.tip_list || [];
        },
        /**
         * 一些基础的显示信息
         */
        showAllBaseData() {
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore.data)
                return {};
            const { editable, finish_config_desc, can_re_config_type, switch_type, save_config_desc, baas_deduction_price, img_url_list, logo_url, img_url, new_version, share_img_url, } = showAllListStore.data;
            return {
                editable: editable ?? 0,
                canReConfig: can_re_config_type ?? 0,
                finish_config_desc,
                switch_type,
                save_config_desc,
                baas_deduction_price: baas_deduction_price ?? 0,
                img_url_list: img_url_list ?? [],
                logo_url,
                img_url,
                new_version: new_version ?? '',
                share_img_url: share_img_url ?? '',
            };
        },
        // 价格明细
        deduction() {
            const showAllListStore = useShowAllListStore();
            const data = showAllListStore?.data;
            if (!data?.category_list)
                return null;
            const deductionItem = data.category_list.find((category) => {
                return category.code === CategoryCode.Deduction;
            });
            if (!deductionItem)
                return null;
            const barList = deductionItem.option_list?.map((optionItem) => {
                const barItem = {
                    configName: optionItem.name,
                    desc: optionItem.desc || '',
                    price: optionItem.price || 0,
                    price_prefix_desc: optionItem.price_prefix_desc,
                    plus_minus_desc: optionItem.plus_minus_desc,
                    tip_desc: optionItem.tip_desc,
                    tip_url: optionItem.tip_url,
                    package_price_desc: optionItem.package_price_desc,
                };
                return barItem;
            }) ?? [];
            const deductionConfig = {
                title: deductionItem.name,
                code: deductionItem.code,
                showRadio: !!deductionItem.order_person_type,
                orderPersonType: deductionItem.order_person_type,
                orderPersonText: deductionItem.order_person_type === 2 ? '企业购车' : '个人购车',
                barList,
            };
            return deductionConfig;
        },
        /**
         * 基础配置
         * @returns
         */
        configCategoryList() {
            const featureList = useFeatureListStore();
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore.data)
                return [];
            if (!showAllListStore.data.category_list)
                return [];
            const optionArray = [];
            showAllListStore.data.category_list.forEach((category) => {
                // 优惠包和价格明细单独剔除
                if (category.code === CategoryCode.Discount ||
                    category.code == CategoryCode.Deduction ||
                    category.code == CategoryCode.Gift ||
                    category.code === CategoryCode.Additional)
                    return;
                const barList = category.option_list?.map((optionItem) => {
                    let popupName = optionItem.name;
                    if (featureList.data) {
                        const pathArr = [
                            category.code,
                            optionItem.sub_category_code,
                        ];
                        const subCategatyData = getFeatureData(pathArr, featureList.data);
                        if (subCategatyData) {
                            popupName = subCategatyData.name ?? optionItem.name;
                        }
                    }
                    const barItem = {
                        code: optionItem.code,
                        feature_code: optionItem.feature_code,
                        name: optionItem.name,
                        subCategoryCode: optionItem.sub_category_code,
                        price_prefix_desc: optionItem.price_prefix_desc,
                        plus_minus_desc: optionItem.plus_minus_desc,
                        price: optionItem.price || 0,
                        package_price_desc: optionItem.package_price_desc || '',
                        imgSrc: optionItem.img_url || '',
                        popupName: popupName,
                        popupOptional: componentMap[optionItem.sub_category_code]?.popupOptional,
                        popupComponent: componentMap[optionItem.sub_category_code]?.componentName,
                        noDetail: optionItem.feature_type === SubCategoryCode.Version,
                        popupOptionsDetail: false,
                        stop_sale_type: optionItem?.stop_sale_type || 0,
                        // 下架tips文案
                        stop_sale_desc: optionItem?.stop_sale_desc || '',
                        // 下架操作文案
                        operate_desc: optionItem?.operate_desc || '',
                        feature_type: optionItem?.feature_type || '',
                        select_discount_tip: optionItem?.select_discount_tip || '',
                        select_discount_tip_icon: optionItem?.select_discount_tip_icon || '',
                        select_discount_tip_icon_ratio: optionItem?.select_discount_tip_icon_ratio || '',
                        origin_price: optionItem?.origin_price || 0,
                        discount_icon_v2: optionItem?.discount_icon_v2 || '',
                        discount_icon_v2_ratio: optionItem.discount_icon_v2_ratio,
                    };
                    // 选配的 单项直接弹出来单项弹窗
                    if ([
                        SubCategoryCode.CockpitCustom,
                        SubCategoryCode.ExteriorCustom,
                        SubCategoryCode.SubOptional,
                    ].includes(optionItem.sub_category_code)) {
                        barItem.popupOptional = componentMap['option_item']?.componentName;
                        barItem.popupOptionsDetail = true;
                    }
                    return barItem;
                }) ?? [];
                const obj = {
                    name: category.name,
                    code: category.code,
                    barList: barList,
                };
                if (category.add_button) {
                    const extra = {
                        name: category.add_button.type === 1
                            ? '修改' + category.add_button.desc ?? ''
                            : '添加' + category.add_button.desc ?? '',
                        status: category.add_button.type === 1 ? 'edit' : 'add',
                    };
                    obj.extra = extra;
                    const popupItem = {
                        popupName: category.add_button.desc,
                        popupComponent: componentMap[category.add_button.sub_category_code]
                            ?.componentName,
                        PopupOptional: componentMap[category.add_button.sub_category_code]
                            ?.popupOptional,
                        traceData: componentMap[category.add_button.sub_category_code]?.traceData ??
                            null,
                    };
                    obj.popupItem = popupItem;
                }
                optionArray.push(obj);
            });
            return optionArray;
        },
        giftModule() {
            const showAllListStore = useShowAllListStore();
            const data = showAllListStore?.data;
            if (!data?.category_list)
                return null;
            const giftItem = data.category_list.find((category) => {
                return category.code === CategoryCode.Gift;
            });
            if (!giftItem)
                return null;
            const barList = giftItem.option_list.map((optionItem) => {
                const barItem = {
                    configName: optionItem.name,
                    desc: optionItem.desc || '',
                    price: optionItem.price || 0,
                    price_prefix_desc: optionItem.price_prefix_desc,
                    plus_minus_desc: optionItem.plus_minus_desc,
                    tip_desc: optionItem.tip_desc,
                    tip_url: optionItem.tip_url,
                    package_price_desc: optionItem.package_price_desc,
                };
                return barItem;
            });
            const giftConfig = {
                title: giftItem.name,
                code: giftItem.code,
                barList,
            };
            return giftConfig;
        },
        /**
         * 精选标配
         */
        standardConfig() {
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore.data)
                return null;
            const standard = showAllListStore.data.category_list_tab?.find((item) => {
                return item.type == TabType.ChoiceStandardConfig;
            });
            if (standard) {
                return standard;
            }
            return null;
        },
        /**
         * 核心标配
         */
        coreConfig() {
            const showAllListStore = useShowAllListStore();
            const featureList = useFeatureListStore();
            const data = showAllListStore?.data;
            if (!data?.category_list)
                return null;
            const coreItem = data.category_list.find((category) => {
                return category.code === CategoryCode.Additional;
            });
            if (!coreItem)
                return null;
            const barList = coreItem.option_list?.map((optionItem) => {
                if (!optionItem.code) {
                    return;
                }
                const code = optionItem.code;
                const optionItemFromMap = featureList.data?.option_map[code];
                return {
                    code: optionItem.code,
                    feature_code: optionItem.feature_code,
                    name: optionItem.name,
                    imgSrc: optionItem.img_url || '',
                    noDetail: !optionItemFromMap?.detail_desc_url,
                    popupOptionsDetail: true,
                    origin_price: optionItem?.origin_price || 0,
                };
            }) ?? [];
            const obj = {
                name: coreItem.name,
                code: coreItem.code,
                barList: barList,
            };
            return obj;
        },
        show_all_list_tab() {
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore.data)
                return [];
            return showAllListStore.data.category_list_tab ?? [];
        },
        /**
         * 处理取消关联的时候自动弹窗,根据传过来的feature_code找到对应的barList
         */
        findRelationComponentData(optionItem) { },
        /**
         * 配置下架弹窗数据
         */
        getOptionStopSalePopup() {
            const showAllListStore = useShowAllListStore();
            if (!showAllListStore.data)
                return null;
            if (showAllListStore.data?.option_stop_sale_popup) {
                return showAllListStore.data?.option_stop_sale_popup;
            }
            return null;
        },
    },
});
